export default __webpack_public_path__ + "static/Cluster_Grenade-9e00be034faaf972e8296c85744789f9.png";